import { render, staticRenderFns } from "./bulma_fieldset2.vue?vue&type=template&id=a9e05784&scoped=true&lang=html"
import script from "./bulma_fieldset2.vue?vue&type=script&lang=js"
export * from "./bulma_fieldset2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e05784",
  null
  
)

export default component.exports